import {
  CLEAR_GLOBAL_INVOICES,
  LOAD_GLOBAL_INVOICES,
  SAVE_GLOBAL_INVOICES_OPTIONS
} from '../actions/globalInvoiceActions';

const initialState = {
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0
  },
  items: [],
  count: 0,
  totalCartera: 0,
  collectedInRange: 0,
  pending: 0
};

const globalInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_GLOBAL_INVOICES.success: {
      return {
        ...state,
        items: action.items,
        count: action.count,
        totalCartera: action.totalCartera,
        collectedInRange: action.collectedInRange,
        pending: action.pending
      };
    }
    case SAVE_GLOBAL_INVOICES_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    }
    case CLEAR_GLOBAL_INVOICES: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default globalInvoiceReducer;
